import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-xray',
  templateUrl: './bestiole.component.html',
  styleUrls: ['./bestiole.component.css']
})
export class BestioleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
